import { Helmet } from 'react-helmet';
import { Link, useParams } from "react-router-dom";


interface ProjectType {
    site_id: string;
    site_client: string;
    site_url: string;
}

interface ProjectTypes {
    projects: ProjectType[];
}

export const Projects = ({projects} : ProjectTypes) => {
    try{
        return (
            <div>
                <Helmet>
                    <title>Projects | A. Page Code</title>
                    <meta name="description" content="A List of Projects" />
                </Helmet>
                {projects.map((project: ProjectType) => (
                    <div className="card" key={project.site_id}>
                        <div className="card-body">
                            <Link to={`/projects/${project.site_url}`}><h5 className="card-title">{project.site_client}</h5></Link>
                        </div>
                    </div>
                ))}
            </div>
        )
    } catch(e){
        return (
            <>{JSON.stringify(projects)}</>
        );
    }
};

export const Project = ({projects} : ProjectTypes) => {
    const { projectID } = useParams<{ projectID: string }>();
    const project = projects.filter(obj => {
        return obj.site_url === projectID
    });
    return (
        <>{JSON.stringify(project)}</>
    )
}